import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=116d788a&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=116d788a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d788a",
  null
  
)

export default component.exports